package com.karyadina.cloudsync.di

import com.karyadina.cloudsync.service.CloudSyncService
import com.karyadina.cloudsync.service.CloudSyncServiceImpl
import com.karyadina.cloudsync.service.CryptoService
import com.karyadina.cloudsync.service.GoogleAuthService
import com.karyadina.cloudsync.service.GoogleDriveService
import com.karyadina.cloudsync.service.GoogleDriveServiceImpl
import com.karyadina.cloudsync.service.IBackgroundSyncService
import com.karyadina.cloudsync.service.SharedLinkService
import com.karyadina.cloudsync.service.SharedLinkServiceImpl
import com.karyadina.cloudsync.service.SharedLinkStorage
import com.karyadina.cloudsync.service.SharedLinkStorageImpl
import com.karyadina.cloudsync.service.SyncEngine
import com.karyadina.cloudsync.service.SyncEngineImpl
import com.karyadina.cloudsync.service.WebBackgroundSyncService
import com.karyadina.cloudsync.service.WebCryptoService
import com.karyadina.cloudsync.service.WebGoogleAuthService
import org.koin.dsl.module

/**
 * Web-specific CloudSync Koin module.
 * Mirrors androidCloudSyncModule but uses Web implementations.
 */
val webCloudSyncModule = module {
    // Platform-specific services (Web implementations)
    single<GoogleAuthService> { WebGoogleAuthService() }
    single<CryptoService> { WebCryptoService() }
    single<IBackgroundSyncService> { WebBackgroundSyncService() }

    // Common services (same as Android)
    single<SharedLinkStorage> { SharedLinkStorageImpl() }

    single<GoogleDriveService> {
        GoogleDriveServiceImpl(
            googleAuthService = get()
        )
    }

    single<SyncEngine> {
        SyncEngineImpl(
            googleDriveService = get(),
            cryptoService = get(),
            googleAuthService = get()
        )
    }

    single<SharedLinkService> {
        SharedLinkServiceImpl(
            storage = get(),
            googleAuthService = get()
        )
    }

    single<CloudSyncService> {
        CloudSyncServiceImpl(
            googleAuthService = get(),
            syncEngine = get(),
            backgroundSyncService = get(),
            subscriptionService = get()
        )
    }
}
